import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http";
import { BehaviorSubject } from "rxjs";
import { JsonApiService } from "@app/core/services/json-api.service";
import { map } from 'rxjs/operators';
import { Config } from "@app/config/config";
import { OrderCommentModel } from "@app/models/order/comment.model";
import { Observable } from "rxjs/Observable";
import { OrderDetailsModel } from "@app/models/order/orderdetails.model";
import { SubmitOrderModel } from "@app/models/order/submitorder.model";
import { CancelOrderItemModel } from "@app/models/order/cancelorderitem.model";

const config = new Config();

@Injectable()
export class OrderService {
    readonly rootUrl = config.webAPIUrl + '/api';

    constructor(private jsonApiService: JsonApiService, private http: HttpClient) {
    }
  
     getOrderMetalStatusList() {
         return this.http.get(this.rootUrl+"/order/metalorderstatus");
     }

     getOrderStatusList() {
        return this.http.get(this.rootUrl+"/order/orderstatus");
    }

    editComment(orderCommentModel: OrderCommentModel): Observable<object> {
        return this.http.post(this.rootUrl + '/order/editcomment', orderCommentModel, {});
    }

    getComment(orderId: number): Observable<object> {
        return this.http.get(this.rootUrl + '/order/getcomment/'+orderId, {});
    }

    getDeliveredOrder(start: number, length: number): Observable<object> {
        return this.http.get(this.rootUrl + '/order/delivered/start/'+start+'/length/'+length, {});
    }

    getUndeliveredOrder(start: number, length: number): Observable<object> {
        return this.http.get(this.rootUrl + '/order/undelivered/start/'+start+'/length/'+length, {});
    }

    submitOrder(order: SubmitOrderModel): Observable<object> {
        return this.http.post(this.rootUrl + '/order/submit', order, {});
    }

    cancelOrder(orderItem: CancelOrderItemModel): Observable<object> {
        return this.http.post(this.rootUrl + '/order/cancel', orderItem, {});
    }

    getOrderUndeliveredListCount() {
        return this.http.get(this.rootUrl+"/order/undelivered/count");
    }

    getOrderDeliveredListCount() {
        return this.http.get(this.rootUrl+"/order/delivered/count");
    }
  }
  